// extracted by mini-css-extract-plugin
export default {"container":"Header_container__A8a8+","left":"Header_left__JSD4P","right":"Header_right__7XgTx","item":"Header_item__F5M6P"};